export class WindowHelper
{
    constructor()
    {
        this.width = this.getWidth();
    }

    getWidth()
    {
        return window.innerWidth || document.documentElement.clientWidth ||
            document.body.clientWidth;
    }

}
